import React from 'react';
import { notificationType } from './../shared_proptypes';
import StatusIcon from '../StatusIcon';
import NotificationItemDetails from "../NotificationItemDetails";

function CustomRegionUploadNotification({ notification }) {
  return (
    <span className="notification-item" data-test-id="notification_template">
      <StatusIcon status={notification.status} />
      <NotificationItemDetails orgType="Network" orgName={notification.orgName} message={notification.message}/>
    </span>
  );
}

CustomRegionUploadNotification.propTypes = {
  notification: notificationType().isRequired
};

export default CustomRegionUploadNotification;
